import { render, staticRenderFns } from "./PsPatientWeeklyTracking.vue?vue&type=template&id=474bbbc4&scoped=true&"
import script from "./PsPatientWeeklyTracking.vue?vue&type=script&lang=js&"
export * from "./PsPatientWeeklyTracking.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientWeeklyTracking.vue?vue&type=style&index=0&id=474bbbc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474bbbc4",
  null
  
)

export default component.exports